import { render, staticRenderFns } from "./ribbon.vue?vue&type=template&id=e7855c8e&scoped=true&"
import script from "./ribbon.vue?vue&type=script&lang=js&"
export * from "./ribbon.vue?vue&type=script&lang=js&"
import style0 from "./ribbon.vue?vue&type=style&index=0&id=e7855c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7855c8e",
  null
  
)

export default component.exports